import React from 'react';
import { ValueLabel } from '@features/ax/shared/ValueLabel';
import { Badge } from '@shared/ui/badge';

interface DetailsProps {
  operation?: any;
}

export const Details: React.FC<DetailsProps> = ({ operation }) => {
  return (
    <div className="space-y-6 pt-2">
      {/* Remark Section */}
      <div className="bg-white p-5 rounded-xl border border-gray-200 border-l-4 border-l-blue-500 shadow-sm">
        <h3 className="text-xs font-semibold text-gray-500 tracking-wider mb-2.5">
          Remark
        </h3>
        <p className="text-sm text-gray-700 leading-relaxed">
          {operation?.notes || 'NA'}
        </p>
      </div>

      {/* Resource Being Repaired Section */}
      <div className="bg-white p-5 rounded-xl border border-gray-200 border-l-4 border-l-orange-500 shadow-sm space-y-4">
        <h3 className="text-xs font-semibold text-gray-500 tracking-wider">
          Resource Being Repaired
        </h3>

        {/* Resource Details Grid */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6 pt-1">
          <ValueLabel
            label="Resource ID"
            value={<span className="font-semibold text-blue-600">{operation?.resourceCard?.resourceId || operation?.resourceOverview?.resourceId || 'NA'}</span>}
          />
          <ValueLabel label="Serial No" value={operation?.resourceCard?.serialNo || 'NA'} />
          <ValueLabel label="Type" value={operation?.resourceCard?.type || 'NA'} />
          <ValueLabel label="Sub Type" value={operation?.resourceCard?.subType || 'NA'} />
          <ValueLabel label="Category" value={operation?.resourceCard?.category || 'NA'} />
          <ValueLabel label="Sub Category" value={operation?.resourceCard?.subCategory || 'NA'} />
          <ValueLabel label="Read Format" value={operation?.resourceCard?.readFormat || 'NA'} />
        </div>
      </div>

      {/* Location Details Section */}
      <div className="bg-white p-5 rounded-xl border border-gray-200 border-l-4 border-l-blue-500 shadow-sm space-y-4">
        <h3 className="text-xs font-semibold text-gray-500 tracking-wider">
          Location Details
        </h3>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6">
          <ValueLabel label="Area" value={operation?.locationDetails?.area || 'NA'} />
          <ValueLabel label="Sub Area" value={operation?.locationDetails?.subArea || 'NA'} />
          <ValueLabel label="Premise" value={operation?.locationDetails?.premise || 'NA'} />
          <ValueLabel label="Unit" value={operation?.locationDetails?.unit || 'NA'} />
          <ValueLabel label="Unit Type" value={operation?.locationDetails?.unitType || 'NA'} />
          <ValueLabel label="Unit Status" value={operation?.locationDetails?.unitStatus || 'NA'} />
          <ValueLabel label="Latitude" value={operation?.locationDetails?.latitude || 'NA'} />
          <ValueLabel label="Longitude" value={operation?.locationDetails?.longitude || 'NA'} />
        </div>
      </div>

      {/* Warehouse Location Detail Section */}
      <div className="bg-white p-5 rounded-xl border border-gray-200 border-l-4 border-l-blue-500 shadow-sm space-y-4">
        <h3 className="text-xs font-semibold text-gray-500 tracking-wider">
          Warehouse Location Detail
        </h3>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-6">
          <ValueLabel
            label="Warehouse Name"
            value={
              operation?.warehouseLocationDetails?.name ||
              operation?.warehouseLocationDetails?.warehouseName ||
              operation?.warehouseDetails?.name ||
              operation?.warehouseDetails?.warehouseName ||
              operation?.warehouseName ||
              'NA'
            }
          />
          <ValueLabel
            label="Address"
            value={
              operation?.warehouseLocationDetails?.address ||
              operation?.warehouseDetails?.address ||
              operation?.warehouseAddress ||
              'NA'
            }
          />
          <ValueLabel
            label="Latitude"
            value={
              operation?.warehouseLocationDetails?.latitude ||
              operation?.warehouseDetails?.latitude ||
              operation?.warehouseLatitude ||
              'NA'
            }
          />
          <ValueLabel
            label="Longitude"
            value={
              operation?.warehouseLocationDetails?.longitude ||
              operation?.warehouseDetails?.longitude ||
              operation?.warehouseLongitude ||
              'NA'
            }
          />

        </div>
      </div>
    </div>
  );
};
